import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';

@MergeSchema({
    entity: ActivityEntityName.Lead
})
export class LeadMergeData {

    @MergeField()
    _id: string;

    @MergeField()
    stage: string;

    @MergeField()
    description: string;

    @MergeField()
    source: string;

    @MergeField()
    tags: string;

    @MergeField()
    createdAt: string;

    @MergeField()
    lastActivity: string;

    @MergeField()
    jobType: string;


}

export const LeadMergeSchema = getSchema(LeadMergeData);